export const OfficialNumbers = {
    USERS: 2000000,
    CITIES: 51,
    DEALS: 12000,
    PARTNERS: 6000,
    GUESTS_PER_MONTH: 300000,
}
